import { render, staticRenderFns } from "./roomChat.vue?vue&type=template&id=290d20f6&scoped=true"
import script from "./roomChat.vue?vue&type=script&lang=js"
export * from "./roomChat.vue?vue&type=script&lang=js"
import style0 from "./roomChat.vue?vue&type=style&index=0&id=290d20f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290d20f6",
  null
  
)

export default component.exports